import React from "react";
import type { BadgeLeading } from "@/src/shared/services/listingBadge";

interface IBadgeLeadingIconProps {
  leading: BadgeLeading;
}

/**
 * The icon before a listing badge's name, as the app's `_badgeLeading`: the API's icon at
 * 14 px, or the emoji fallback at 12 px (`listingBadgeService.leading` picks which).
 */
const BadgeLeadingIcon: React.FC<IBadgeLeadingIconProps> = ({ leading }) => {
  if (!leading) return null;
  if (leading.kind === "image") {
    return (
      <img src={leading.src} alt="" className="h-3.5 w-3.5 object-contain" />
    );
  }
  return <span className="text-12 leading-none">{leading.emoji}</span>;
};

export default BadgeLeadingIcon;
